import { formatDate, gridSize,  gridSizeMdLg4, newTransferenciaSchema, ROUTER_PATHS, texto, useUploadFile } from "@/shared";
import { LoaderComponent, SingleTableBoxScene, TabTextLabel } from "@/shared/components/ui";
import { AlertSeverityEnum, EstadoSolicitudTransferencia, EstadosSolicitudPeodidoEnum, ISolicitudTrasladoForm, MaterialTransferido } from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { Alert, Grid, Paper } from "@mui/material";
import DatosTransferenciaComponente from "@/erp/inventario/componente/datos-transferencia-componente";
import { useNavigate, useParams } from "react-router-dom";
import ModalUbicacionProductoSelectComponente from "@/erp/inventario/ingreso-producto/shared/componente/ModalUbProductoSelectComponente";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { useTableColumnsTrasladoSerie } from "@/shared/hooks/useTableColumnsTrasladoSerie";
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";

import { EgresoDialog } from "@/shared/components/ui/EgresoDialog";
import { useEffect, useMemo, useState } from "react";
import {  getUbicacionProductoSimple, useFetchCreateTransferenciaInventario,  useGetSolicitudPedido, useUpdateSolicitudesEgresos } from "@/shared/actions/erp";
import ModalInventariableProductoFactor from "@/shared/components/ui/CargarSeries/ModalInventariableProductoFactor";

export default function TrasladoInventarioCrearPage() {
  const { id_solicitudegreso } = useParams()
  //*form
  const form = useForm<ISolicitudTrasladoForm, any, ISolicitudTrasladoForm>({
    resolver: yupResolver(newTransferenciaSchema),
    defaultValues: {
      solicitado_por: "",
    }
  })
  const {
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = form;
  //*
  const setConfirmDialog = useUiStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore(s => s.setConfirmDialogIsOpen);
  //*store
  const setAlert = useUiStore(s => s.setAlert)
  const handleAgregarUrlSerie = useCargarSeriesProductos(s => s.handleAgregarUrlSerie)
  const { handleUploadFile } = useUploadFile();
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const productos = useCargarSeriesProductos(s => s.productos)
  const setPagination = useCargarSeriesProductos(s => s.setPagination)
  const pagination = useCargarSeriesProductos(s => s.pagination)
  const handleAgregarProducto = useCargarSeriesProductos(s => s.handleAgregarProducto)
  const handleCopiarLista = useCargarSeriesProductos(s => s.handleCopiarLista)
  const clearSelectedItems = useCargarSeriesProductos(s => s.clearSelectedItems)
  const navigate = useNavigate()

  //
  const { columnsIngresoInventario, deleteProductoId } = useTableColumnsTrasladoSerie()
  //state
  const [productoNoEncontrado, setProductoNoEncontrado] = useState<MaterialTransferido[]>([])
  const [formData, setFormData] = useState<ISolicitudTrasladoForm | null>(null);
  //
  const [onlyDispatch, setOnlyDispatch] = useState(false)
  const [dispatchFinalize, setDispatchFinalize] = useState(false)
  const [isOpenModal2, setIsOpenModal2] = useState(false)
  const [producto, setProducto] = useState<any[]>([])
  const [codigoNoEnContrados, setCodigoNoEnContrados] = useState<string[]>([])
  const [isActiveAlert, setIsActiveAlert] = useState(false)
  const [isEstadoNormal, setIsEstadoNormal] = useState(false)
  //


  //**fetch */

  const updateSolicitudesPedidos = useUpdateSolicitudesEgresos({
    enableSuccessAlert: false
  })

  const {
    data: dataSolicitudPedidoId
  } = id_solicitudegreso ? useGetSolicitudPedido(id_solicitudegreso) : { data: null }

  const {
    mutateAsync: fetchCreateTransferenciaProducto,
    isPending: isPendingTraslado
  } = useFetchCreateTransferenciaInventario();

  //**compara el tamaño */
  useEffect(() => {
    if (deleteProductoId.length === 0) return
    setCodigoNoEnContrados(prevCodActual => prevCodActual.filter(codigo => !deleteProductoId.includes(codigo)))
  }, [deleteProductoId])

  //**
  const bodegaOrigen = form.watch('bodega_origen');
  const ubicacionOrigen = form.watch('ubicacion_origen')


  useEffect(() => {

    if (!bodegaOrigen) {
      setIsEstadoNormal(true)
      clearSelectedItems()
      setIsActiveAlert(false)
      setCodigoNoEnContrados([])

    } else {
      setIsEstadoNormal(false)
      setCodigoNoEnContrados([])

    }
  }, [bodegaOrigen])

  useEffect(() => {
    if (ubicacionOrigen) {
      setCodigoNoEnContrados([])
    }

  }, [ubicacionOrigen])
  //logica 
  const cargaProductos = useMemo(() => {
    //clearSelectedItems()
    if (!dataSolicitudPedidoId?.data.productos) return [];
    return dataSolicitudPedidoId?.data.productos?.map(item => ({
      ...item,
      cantidad: item.cantidad ?? 0,
      codigo: item.codigo ?? "",
      id: item.id ?? "",
      cantidad_recibida: item.cantidad_recibida ?? 0,
      cantidad_aprobada: item.cantidad_aprobada ?? 0,
      descripcion: item.descripcion ?? "",
      stock_actual: item.stock_actual ?? "0",
      id_producto: item.id_producto ?? "",
    }))
  }, [id_solicitudegreso, dataSolicitudPedidoId])

  useEffect(() => {
    if (!cargaProductos.length) return;
    handleCopiarLista(cargaProductos)
  }, [cargaProductos, isEstadoNormal])

  //
  useEffect(() => {
    if (!id_solicitudegreso && !dataSolicitudPedidoId) return;
    form.setValue('bodega_destino', dataSolicitudPedidoId?.data?.bodega!)
    form.setValue('ubicacion_destino', dataSolicitudPedidoId?.data?.ubicacion_data?.codigo!)
    //form.setValue('ubicacion_destino', dataSolicitudPedidoId?.data?.ubicacion_data?.nombre!)
  }, [dataSolicitudPedidoId, id_solicitudegreso])

  //**busca producto */
  useEffect(() => {
    const buscarProductoEnOrigen = async () => {

      const ubicacionOrigen = form.getValues().ubicacion_origen
      if (!ubicacionOrigen) return;

      const productos = dataSolicitudPedidoId?.data?.productos;
      if (!productos || productos.length === 0) return;
      //array para productos no Encontrados
      const productosNoEncontrados: any[] = [];

      //creamos nuevo objeto solo cantidad y codigo
      const productoConCantidad = productos.map((item) => ({
        codigo: item.codigo,
        cantidad_aprobada: item.cantidad_aprobada
      }));

      //*busca las peticones asincronas de los productos
      const response = await Promise.all(

        productos.map(async (element) => {
          /* const resp = await getUbicacionProductos({ */
          const resp = await getUbicacionProductoSimple({
            page_size: 600,
            //producto: element.codigo,
            productos: element.codigo,
            ubicacion: form.getValues().ubicacion_origen!
          })
          if (!resp.data.data.length) {
            productosNoEncontrados.push(element)
          }
          return resp.data.data;
        })
      )
      const resp = response.flat();

      //asignar cantidades a los productos encontrados

      const asignacionProducto = resp.map((elemento) => {
        const cantidadproducto = productoConCantidad.find((item) => item.codigo === elemento.producto_data?.codigo)
        return {
          ...elemento,
          cantidad: cantidadproducto?.cantidad_aprobada
        }
      })
      setProducto(asignacionProducto)
      if (!productosNoEncontrados || productosNoEncontrados.length === 0) return;
      productoNoExiste(productosNoEncontrados)
    }

    buscarProductoEnOrigen();

  }, [form.watch('bodega_origen'), form.watch('ubicacion_origen')])

  //funcion productos no encontrados
  const productoNoExiste = (productosNoEncontrado: any[]) => {
    const aux: MaterialTransferido[] = productosNoEncontrado.map((elemento) => ({
      id: elemento.id,
      codigo: elemento?.codigo,
      cantidad: elemento?.cantidad_aprobada,
      producto_data: {
        codigo: elemento?.codigo,
        categoria_producto: elemento?.categoria_producto,
        subcategoria_producto: elemento?.subcategoria_producto,
        descripcion: elemento?.descripcion,
        stock_actual: elemento.stock_actual ?? 0
      },
      series: []
    }))

    setProductoNoEncontrado(aux)
    handleCopiarLista(aux)
    setCodigoNoEnContrados(prev => [...prev, ...aux.map(p => p.codigo)])
  }

  const productosEncontrados = () => {
    if (!producto.length || producto.length === 0) return;
    const aux: MaterialTransferido[] = producto.map((elemento) => ({

      id: elemento.id_ubicacion_producto!,
      contiene_serie: false,
      codigo: elemento.producto_data?.codigo,
      cantidad: elemento?.cantidad,
      series: [],
      producto_data: {
        codigo: elemento.producto_data?.codigo,
        categoria_producto: elemento.producto_data?.categoria_producto,
        subcategoria_producto: elemento.producto_data?.subcategoria_producto,
        descripcion: elemento.producto_data?.descripcion,
        stock_actual: elemento?.stock,
      },
      ubicacion_origen: elemento?.ubicacion

    }))


    if (dataSolicitudPedidoId?.data.productos?.length === productoNoEncontrado.length) {
      setAlert(true, 'Todos los productos solicitados están disponibles en esta ubicación.', AlertSeverityEnum.success)
      handleCopiarLista(aux);
      return
    }

    if (!productoNoEncontrado.length) {
      setAlert(true, 'Todos los productos solicitados están disponibles en esta ubicación.', AlertSeverityEnum.success)
      handleCopiarLista(aux)
      setCodigoNoEnContrados([])
      return;
    }

    const productoFiltrados = aux.filter(
      (item) => !productoNoEncontrado.some((prev) => prev.codigo === item.codigo)
    )

    if (productoFiltrados.length === 0) return;


    if (productoNoEncontrado.length > 0) {

      const nuevoArray = [...productoFiltrados, ...productoNoEncontrado]

      setAlert(true, 'En la ubicación seleccionada no se encontraron todo los productos solicitados.', AlertSeverityEnum.warning)

      handleCopiarLista(nuevoArray)
      setProductoNoEncontrado([])

    }

    /* if (productoNoEncontrado.length !== aux.length) {
        console.log('entro al aarray')
      const nuevoArray = [...productoFiltrados, ...productoNoEncontrado]
      
      setAlert(true, 'En la ubicación seleccionada no se encontraron todo los productos solicitados.', AlertSeverityEnum.warning)
      console.log('nuevoarray',nuevoArray)
      handleCopiarLista(nuevoArray)
      setProductoNoEncontrado([])
    } */
  }

  useEffect(() => {
    if (producto.length > 0) {
      productosEncontrados()
    }
  }, [producto])

  useEffect(() => {
    if (producto.length === 0 && productoNoEncontrado.length > 0) {
      if (dataSolicitudPedidoId?.data.productos?.length === productoNoEncontrado.length) {
        setAlert(true, 'Ninguno de los productos solicitados está disponible en esta ubicación.', AlertSeverityEnum.info)
      }
    }
  }, [producto, productoNoEncontrado])

  //*alerta
  useEffect(() => {
    if (codigoNoEnContrados.length > 0) {
      setIsActiveAlert(true)
    } else {
      setIsActiveAlert(false)
    }

  }, [codigoNoEnContrados])

  //* save
  const onSave = (e: ISolicitudTrasladoForm) => {

    if (productos.length === 0) return setAlert(true, 'Agregar Productos.', AlertSeverityEnum.info)
    if (codigoNoEnContrados.length > 0) return setAlert(true, 'Productos no disponibles en la ubicación seleccionada. Verifique las existencias.', AlertSeverityEnum.error)

    const prod = productos.find(e => e.cantidad == '0')
    if (prod) {
      return setAlert(true, `El inventariable ${prod.codigo} tiene una cantidad de cero.`, AlertSeverityEnum.info)
    }

    //valida serie
    const productoConError = productos.find(({ contiene_serie, series, cantidad }) =>
      contiene_serie && (
        series?.length == 0 || series?.length! != cantidad
      ))
    if (productoConError) {
      const { codigo } = productoConError.producto_data ?? {}
      const mensaje = productoConError.series?.length == 0
        ? `El producto con el código ${codigo} tiene series pendientes por cargar.`
        : `El producto con el código ${codigo} tiene una discrepancia entre la cantidad ingresada y las series cargadas. Por favor, revisa la información y vuelve a intentarlo.`;
      return setAlert(true, mensaje, AlertSeverityEnum.error)
    }
    //*verify stock_actual
    const resul = productos.some((item) => Number(item.cantidad) > Number(item.producto_data?.stock_actual))
    if (resul) return setAlert(true, texto.egreso_sin_stock, AlertSeverityEnum.error)
    //*call funtion 
    if (id_solicitudegreso) {
      setIsOpenModal2(true)
      setFormData(e)
    } else {
      handleConfirmar(e)
      setOnlyDispatch(true)
    }
  }
  //* useEffet
  useEffect(() => {
    if (onlyDispatch || dispatchFinalize) {
      setIsOpenModal2(false)
      setTimeout(() => {
        if (formData) handleConfirmar(formData)
      }, 300)
    }
  }, [onlyDispatch, dispatchFinalize])
  //*modal
  const handleConfirmar = (e: ISolicitudTrasladoForm) => {

    setConfirmDialogIsOpen(true)
    setConfirmDialog({
      cancelTextBtn: 'Salir',
      isOpen: true,
      title: '¡Confirmar!',
      subtitle: 'Confirmar que deseas proceder con el traslado de inventario. Esta acción es irreversible.¿Estás seguro de continuar?',
      onClose() {
        setConfirmDialogIsOpen(false)
        setDispatchFinalize(false)
        setOnlyDispatch(false)
      },
      async onConfirm() {
        await handleMutation(e)
      },
    })
  }
  //handleMutation
  const handleMutation = async (e: ISolicitudTrasladoForm) => {
    setConfirmDialogIsOpen(false)
    try {
      const newProductoData = await handleAgregarUrlSerie(handleUploadFile)

      const traslado: any = {
        ...e,
        estado_solicitud: EstadoSolicitudTransferencia.FINALIZADO,
        fecha: formatDate(new Date),
        productos: newProductoData
      }

      const respTraslado = await fetchCreateTransferenciaProducto(traslado);

      if (respTraslado.code !== 200) {
        setDispatchFinalize(false)
        setOnlyDispatch(false)
        return;
      }

      if (dispatchFinalize) {

        const solicitudPedido = {
          id: id_solicitudegreso,
          data: {
            estado_solicitud: EstadosSolicitudPeodidoEnum.FINALIZADO
          }
        } as any

        await updateSolicitudesPedidos.mutateAsync(solicitudPedido)
        setOnlyDispatch(false)
        setDispatchFinalize(false)
      }

      navigate(ROUTER_PATHS.inventario.trasladoInventario);
      clearSelectedItems()


    } catch (error) {
      setDispatchFinalize(false)
      setOnlyDispatch(false)

    } finally {
      setDispatchFinalize(false)
      setOnlyDispatch(false)
    }
  }

  useEffect(() => {
    return () => {
      clearSelectedItems()
    }
  }, [])
  //*mutation
  if (isPendingTraslado)
    return <LoaderComponent />

  return (
    <>
      <SingleTableBoxScene
        title="📦Crear Transferecia de inventario"
        visibleReport={false}
        enableBackBtn={true}
        backPageUrl={ROUTER_PATHS.inventario.trasladoInventario}
        enableCreateOrEditBtn={true}
        textCreateOrEditBtn="Trasferir"
        iconCreateOrEdit={<LocalShippingIcon />}
        fnCreateOrEdit={handleSubmit(onSave,
          () => {
            setAlert(true, texto.campos_obligatorios, AlertSeverityEnum.error);
          }
        )}
      >
        <Grid container spacing={2} justifyContent={'center'}>
          <DatosTransferenciaComponente
            control={control}
            errors={errors}
            form={form}
            reset={reset}
            onChangeDeleteItem={() => {
              //clearSelectedItems()
            }}
            idsolicitudEgreso={id_solicitudegreso}
          />
          {!form.getValues().ubicacion_origen && (
            <Grid item {...gridSize}>
              <Alert severity="info">
                <strong>{'Paso requerido:'}</strong>
                {'Seleccione la bodega y ubicación desde donde harás la transferencia. Para verificar la disponibilidad de los productos solicitados.'}
              </Alert>
            </Grid>
          )}
          {isActiveAlert === true && (
            <Grid item {...gridSize}>
              <Alert severity="warning">
                <strong>{'Upps:'}</strong>
                {'Intente buscar en otra ubicación o genere un ingreso de inventario.'}
              </Alert>
            </Grid>
          )}
          {!isActiveAlert && form.getValues().bodega_origen && form.getValues().ubicacion_origen && (
            <Grid item {...gridSize}>
              <Alert severity="success">
                <strong>{'¡Listo!'}</strong> {'Productos encontrados. Puedes continuar.'}
              </Alert>
            </Grid>
          )}
          <Grid item {...gridSize}>
            <Paper className="paper-producto">
              <Grid container spacing={1} justifyContent={'space-between'} alignItems={'center'}>
                <Grid item>
                  <TabTextLabel text={'Items Selecionado'} mt={0} pb={0} pl={0} pt={0} />
                </Grid>
                <Grid item>
                  <ModalUbicacionProductoSelectComponente
                    ubicacion={form.getValues().ubicacion_origen!}

                    control={control}
                    onChange={(e) => {
                      const aux: MaterialTransferido = {
                        id: e.id_producto!,
                        contiene_serie: e.contiene_serie,
                        codigo: e.codigo,
                        cantidad: 1,
                        producto_data: {
                          codigo: e.codigo,
                          categoria_producto: e.categoria_producto,
                          subcategoria_producto: e.subcategoria_producto,
                          descripcion: e.descripcion,
                          stock_actual: e.stock_actual,
                        },
                        series: [],
                        metros_actuales: e.metros_actuales,
                        usa_metros: e.usa_metros,

                        ///* Helper
                        ubicacion_origen: form.getValues().ubicacion_origen!,
                        ubicacion_destino: form.getValues().ubicacion_destino!,
                      }
                      //console.log('auxiliar',aux)
                      handleAgregarProducto(aux)
                    }}
                  />
                </Grid>
                <div className="linea"></div>
                <Grid item xs={12}>
                  <SampleTablePagination
                    columns={columnsIngresoInventario}
                    data={paginatedData}
                    rowCount={productos.length}
                    setPagination={setPagination}
                    pagination={pagination}
                    rowNumber={true}
                  />
                </Grid>
              </Grid>

            </Paper>

          </Grid>

        </Grid>
      </SingleTableBoxScene>
      {/*  <ModalProductoSeries
        generarSerie={false}
        seleccionarAutomatico={false}
        seleccionarManual={true}
        size={gridSizeMdLg3}
      /> */}
      <ModalInventariableProductoFactor
        generarSerie={false}
        seleccionarAutomatico={true}
        seleccionarManual={true}
        size={gridSizeMdLg4}
      />
      <EgresoDialog
        open={isOpenModal2}
        onClose={() => setIsOpenModal2(false)}
        onOnlyDispatch={() => { setOnlyDispatch(true), setIsOpenModal2(false) }}
        onDispatchFinalize={() => { setDispatchFinalize(true), setIsOpenModal2(false) }}
      />
    </>
  )
}